import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NortonDetailsComponent } from './norton-details/norton-details.component';
import { Norton360DetailsComponent } from './norton360/norton360-details/norton360-details.component';
import { AuOnlyGuard } from '../guards/au-only.guard';
import { MyProximusAuthenticationCheckGuard } from '../guards/myproximus-authentication-check.guard';

const routes: Routes = [
  {
    path: 'norton',
    component: NortonDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard, AuOnlyGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts norton products',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'norton products',
          },
        },
      },
    },
  },
  {
    path: 'norton360',
    component: Norton360DetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard, AuOnlyGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts norton 360 products',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'norton 360 products',
          },
        },
      },
    },
  },
  {
    path: 'norton/:mpcUuid',
    component: NortonDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard, AuOnlyGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts norton products',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'norton products',
          },
        },
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NortonRoutingModule {}
